export default {
  'MobileSideDropdown.Wrapper.Wrapper.CloseIcon': ({ selectedOptionIds, noTagIds }, outlet) => {
    outlet({ action: 'close', selectedOptionIds, noTagIds })
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.TitleWrapper.GoBack': ({ selectedOptionIds, noTagIds }, outlet) => {
    outlet({ action: 'close', selectedOptionIds, noTagIds })
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.SearchWrapper.SearchInput(Keydown)': ({ value, key }, _, internalStateSetter) => {
    if (key === 'Enter') {
      internalStateSetter({ searchTerm: value })
    }
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.SearchWrapper.SearchInput': ({ value }, _, internalStateSetter) => {
    internalStateSetter({ inputVal: value });
    if (!value) {
      internalStateSetter({ searchTerm: '' });
    }
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.SearchWrapper.Search': ({ inputVal }, _, internalStateSetter) => {
    internalStateSetter({ searchTerm: inputVal })
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.OptionsWrapper.Option': ({ id, selectedOptionIds }, _, internalStateSetter) => {
    let newIds = [];
    if (selectedOptionIds?.includes(id)) {
      newIds = selectedOptionIds.filter(i => i !== id);
    } else {
      newIds = [...selectedOptionIds, id]
    }
    internalStateSetter({ selectedOptionIds: newIds });
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.Button': ({ selectedOptionIds, noTagIds }, outlet) => {
    outlet({ action: 'close', selectedOptionIds, noTagIds })
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.ClearAllHeader.ClearAll': ({ selectedOptionIds, options }, _, internalStateSetter) => {
    if (selectedOptionIds.length > 0) {
      internalStateSetter({ selectedOptionIds: [], noTagIds: [] });
    } else {
      internalStateSetter({ selectedOptionIds: options.map(o => o.id), noTagIds: [] });
    }
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.OptionsWrapper.LoadMore': ({ pageNumber }, _, internalStateSetter) => {
    internalStateSetter({ pageNumber: pageNumber + 1 })
  },
  'MobileSideDropdown.Wrapper.Wrapper.ButtonsWrapper.OptionsWrapper.NoTag': async ({ noTagIds, makeReadyCategory }, outlet, internalStateSetter) => {
    if (noTagIds.includes(makeReadyCategory.id)) {
      internalStateSetter({ selectedOptionIds: [], noTagIds: noTagIds?.filter(t => t !== makeReadyCategory.id) });
    } else {
      outlet({ action: 'close', selectedOptionIds: [], noTagIds: [...(noTagIds ?? []), makeReadyCategory.id] });
    }
    await internalStateSetter({ isOpen: false, pageNumber: 1, searchVal: '' });
  },
}